import React from 'react'
import Button from "../../../components/Button";
import {PageSection} from "../../../components/PageSection";
import ngage from "../../../services/ngage";
import {useNotifications} from "../../../context/NotificationContext";
import {useNavigate} from "react-router-dom";
import {useMutation} from "react-query";

// Types ----

type TwoFactorAuthChooseAppProps = {
  onContinue: () => void;
}

// Component ----

function TwoFactorAuthChooseApp({onContinue}: TwoFactorAuthChooseAppProps) {
  const {notify} = useNotifications();
  const navigate = useNavigate();

  const {mutate: enableTwoFactorAuth, isLoading} = useMutation(ngage.auth.twoFactorEnable, {
    onSuccess: onContinue,
    onError: () => notify("error", "Two-factor Authentication", "Something went wrong, please try again."),
  });

  return (
    <PageSection
      title='Download an authenticator app'
    >
      <div className="flex flex-col gap-4 text-gray-900 text-sm">
        <p>Authenticator apps generate unique codes that change frequently, providing a secure way to verify your
          identity. They are usually mobile apps.</p>

        <p>There are a variety of authenticator apps out there. Some popular options include:</p>

        <ul className="list-disc ml-6 flex flex-col gap-1.5">
          <li>Google Authenticator</li>
          <li>Duo Mobile</li>
          <li>Microsoft Authenticator</li>
          <li>1Password</li>
          <li>Lastpass Authenticator</li>
        </ul>

        <p>Once you have chosen and downloaded an authenticator app, select continue below.</p>

        <div className='flex gap-4 mt-4'>
          <Button
            color={Button.colors.PRIMARY}
            onClick={() => enableTwoFactorAuth()}
            showSpinner={isLoading}
            disabled={isLoading}
          >
            Continue
          </Button>

          <Button
            color={Button.colors.WHITE}
            onClick={() => navigate('/user-settings')}
          >
            Cancel
          </Button>
        </div>
      </div>
    </PageSection>
  );
}

export {TwoFactorAuthChooseApp};